import store from '../../../../store'

export default function StationsCounter(opts){
    BaseConstructor.call(this)
    let container = opts.container
    let chart_name = opts.chart_name
    let elements = {}
    let context = this

    this.generate = () =>{
        elements.container = this.createElement('div')
        $(container).html(elements.container)

        this.update()

        store.subscribe('chart_nested_prop_update', data=>{
            if(data.chart_name == chart_name && (data.prop_path == 'stations_list.flu.ids' || data.prop_path == 'stations_list.plu.ids')){
                this.update()
            }
        })
    }

    this.update = () =>{
        let stations_list = store.getChartNestedProp(chart_name, 'stations_list')
        let ids = [].concat(_.get(stations_list, 'flu.ids', []), _.get(stations_list, 'plu.ids', []))
        $(elements.container).html(`<span class='badge bg-faded-info text-info fs-sm'>${ids.length} posto${ids.length>1? 's' : ''}</span>`)
    }
}

StationsCounter.prototype = Object.create(BaseConstructor.prototype)